import React, {useEffect, useState} from 'react'
import {Typography} from '@mui/material'
import {useDispatch} from 'react-redux'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import {MoonLoader} from 'react-spinners'
import dayjs from 'dayjs'
import {useHistory} from 'react-router-dom'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import {hasPermission} from '../../../../../_helper/hasPermission'
import {permissions} from '../../../../../_constants/permissions'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {Button} from '@mui/material'
import axios from 'axios'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import DownloadDialog from './DownloadDialog'
import {
  BEHAVIOUR_ASSESSMENT_LISTING_COLUMNS,
  BEHAVIOUR_ASSESSMENT_SORTING_COLUMNS,
  BEHAVIOUR_ASSESSMENT_COLUMNS_DATA_MAPPING,
} from '../BEHAVIOUR_TABLE_CONSTANTS'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import NoteEntryModal from '../../../../reusable-components/Modals/NoteEntryModal'

const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const BehaviourNotesAssessmentList = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [deletedID, setDeletedID] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(false)
  const [showDownloadDialog, setShowDownloadDialog] = useState(false)
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const companyLogo = auth?.user?.companyLogo
  const [logoUrl, setLogoUrl] = useState('')
  const timeZone = useSelector(selectTimeZone)
  const history = useHistory()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const [fullData, setFullData] = useState<any[]>([])
  const [isNoteEntryModalOpen, setIsNoteEntryModalOpen] = useState(false)

  const handleRedirectToNewPage = (data: any) => {
    if (data.clientId && data.noteType) {
      const {existingAssessment} = data?.data
      history.push({
        pathname: `/notes/behavior-notes/new/${existingAssessment?._id}/${data?.clientId}/${data?.noteType}`,
      })
    }
  }

  const handleNoteEntryModalClose = () => {
    setIsNoteEntryModalOpen(false)
  }

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      try {
        setIsFetchingData(true)
        const response = await axios.get('/behavior-assessment/getAll', {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
          },
        })
        const data = response.data.data
        setFullData(data)
        setFilteredData(data)
        setIsFetchingData(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        toast.error('Failed to fetch data')
        setIsFetchingData(false)
      }
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
    deletedID
  ])
   const fetchPresignedUrl = async (key: string) => {
    try {
      if (key?.startsWith('http')) {
        console.log('Already a URL, skipping presigned URL fetch.')
        setLogoUrl(key)
        return
      }

      const response = await axios.get(`/batchfile/fetch-file-url`, {
        params: {fileKey: key},
      })

      if (response.status === 200) {
        setLogoUrl(response.data.presignedUrl)
      }
    } catch (error) {
      console.error('Error fetching company logo URL:', error)
    }
  }

  useEffect(() => {
    if (companyLogo) {
      fetchPresignedUrl(companyLogo)
    }
  }, [companyLogo])
  const handleUpdate = (row: any) => {
    history.push(`/notes/behavior-notes/${row._id}`)
  }

  const handleDelete = async (row: any) => {
    try {
      const response = await axios.delete(`/behavior-assessment/${row._id}`)
      if (response.status === 200) {
        toast.success('Assessment deleted successfully')
        setDeletedID(row._id)
      }
    } catch (error) {
      console.error('Error deleting assessment:', error)
      toast.error('Failed to delete assessment')
    }
  }

  const handleView = (row: any) => {
    history.push(`/notes/behavior-notes/list/${row._id}/${row.clientId}/${row?.noteType}`)
  }
    const handleDeletedAssessments = () => {
    history.push(`/deleted-notes/behaviour-notes/list`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        <div>
          <TableTitle title='Behavior Assessment' />
          <TableWrapper
            searchField={
              <TableSearchBar
                label='Search'
                variant='outlined'
                size='small'
                value={searchTerm}
                setQueryData={setQueryData}
                setSearchTerm={setSearchTerm}
                margin='normal'
              />
            }
            tableButtons={
                <span style={{display: 'flex', gap: '10px'}}>
                  {/* notes_behavior_note_delete */}
                  {hasPermission(userPermissions, permissions.notes_behavior_note_delete)  &&
                    <Button
                      variant={'contained'}
                      color={'primary'}
                      onClick={handleDeletedAssessments}
                    >
                    Deleted Assessments
                    </Button>
                  }
                  {hasPermission(userPermissions, permissions.notes_behavior_note_download) && (
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => setShowDownloadDialog(true)}
                    >
                      Download
                    </Button>
                  )}
                  {hasPermission(userPermissions, permissions.notes_behavior_note_create) && (
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => setIsNoteEntryModalOpen(true)}
                    >
                      Add Note Entry
                    </Button>
                  )}
                  {hasPermission(userPermissions, permissions.notes_behavior_note_create) && (
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => history.push('/notes/behavior-notes/new')}
                    >
                      Add Assessment
                    </Button>
                  )}
                </span>
            }
            dynamicTable={
              <>
              <span className='ml-2 text-primary d-flex align-items-center gap-2'>For view Behavior notes please click on <VisibilityOutlinedIcon /> icon in the table</span>
              <DynamicTable
                columns={BEHAVIOUR_ASSESSMENT_LISTING_COLUMNS}
                canUpdate={hasPermission(userPermissions, permissions.notes_behavior_note_update)}
                onUpdate={handleUpdate}
                canView={hasPermission(userPermissions, permissions.notes_behavior_note_entry_view)}
                onView={handleView}
                canDelete={hasPermission(userPermissions, permissions.notes_behavior_note_delete)}
                onDelete={handleDelete}
                data={filteredData}
                sortingColumns={BEHAVIOUR_ASSESSMENT_SORTING_COLUMNS}
                clickableRow={false}
                queryData={queryData}
                setQueryData={setQueryData}
                title='Are you sure you want to delete this behavior assessment?'
                tableLoader={isFetchingData}
                columnDataMapping={BEHAVIOUR_ASSESSMENT_COLUMNS_DATA_MAPPING}
              />
              </>
            }
          />
        </div>
      </div>

      <NoteEntryModal
        open={isNoteEntryModalOpen}
        onClose={handleNoteEntryModalClose}
        noteCheckingRoute="/behavior-assessment/checkExisting"
        redirectToNewPage={handleRedirectToNewPage}
      />
      {/* Download Dialog */}
      <DownloadDialog
        open={showDownloadDialog}
        onClose={() => setShowDownloadDialog(false)}
        companyLogo={companyLogo}
        logoUrl={logoUrl}
      />
    </div>
  )
}

export default BehaviourNotesAssessmentList
